import React, { useState } from "react";

function PresidentMessageSection() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <section id="about" className="section president-section">
      <div className="container">
        <div className="president-content">
          <p className="president-label">Welcome Message</p>
          <h2 className="president-title">
            Greetings from the Organizing Committee
          </h2>

          <div className="president-body">
            {/* The first paragraph contains the "Read More" button inline */}
            <p>
              Dear Esteemed Colleagues, Greetings from the Organizing Committee of
              the IASG Mid-Term Conference 2026 and the Department of Surgical
              Gastroenterology & Liver Transplantation, IGIMS, Patna. It gives us
              immense pleasure to extend a warm and cordial invitation to you for
              the Mid-Term Conference of the Indian Association of Surgical
              Gastroenterology (IASG), scheduled to be held on 28th & 29th March
              2026 at Patna, Bihar.
            </p>
            <p>
              Bihar, a land of profound historical and cultural significance, is
              revered as the birthplace of Lord Buddha, Lord Mahavira, Sita
              Mata, and Shri Guru Gobind Singh Ji. Recognised globally as an
              International Religious Tourist Circuit, the state is also
              renowned for its rich traditions, warm hospitality, and
              distinctive culinary delights such as Litti Chokha, Champaran
              Mutton, Khama, and Thekua, offering delegates a truly immersive
              cultural experience.
              
            </p>
            <p>
              The conference, themed "G.I. Oncology: From Basics to Clinical
              Practice", aims to serve as a beacon of scientific excellence in
              the field of Surgical Gastroenterology. It will be useful for
              Resident of General Surgery/ Onco. Surgery/ Pediatric
              Surgery/Practicing General Surgeons, G.I.Surgeons and
              Onco.Surgeons.
              {!isExpanded && (
                <button onClick={toggleReadMore} className="inline-toggle-btn">
                  ... Read More
                </button>
              )}
            </p>

            {/* These paragraphs only show when isExpanded is true */}
            {isExpanded && (
              <div className="expanded-text-flow">
                <p>
                  Our meticulously curated two-day scientific programme is designed
                  to comprehensively address recent updates and evolving practices
                  in Surgical Gastroenterology. The programme will feature orations,
                  keynote addresses, expert lectures, panel discussions, and
                  debates, encompassing Open Surgery, Minimally Invasive Surgery,
                  Robotic Surgery, and Advanced Endoscopic Interventions.
                </p>
                <p>
                  We eagerly look forward to your enthusiastic participation as we
                  come together to celebrate excellence, innovation, and camaraderie
                  in the noble pursuit of knowledge and progress in Surgical
                  Gastroenterology.
                </p>
                <p>
                  We would be honored to welcome you to the holy land of Pataliputra (Patna).
                </p>
                <p>With warm regards,</p>
                <p className="president-signature">
                  Organizing Committee, IASG Mid-Term Conference 2026
                </p>
                <p>
                  Department of Surgical Gastroenterology & Liver Transplantation
                </p>

                {/* <Button onClick={toggleReadMore} className="inline-toggle-btn show-less"> 
                  Read Less
                </Button> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PresidentMessageSection;